import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '='
    },
    template: `
        <div class="well color01">
            <h2>{{ 'course.Course history' | translate }}</h2>
            <pagination-tools custom-options="[5,10]" list="vm.list"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="tablewrapper">
                <table ng-if="!vm.list.loading && vm.list.items.length"
                class="data01"
                datatable dt-options="vm.DATATABLES">
                    <thead>
                    <tr>
                        <th>{{ 'course.Course' | translate }}</th>
                        <th>{{ 'course.Field' | translate }}</th>
                        <th ng-if="vm.isOptionalCoursesModuleEnabled">
                            {{ 'course.Participation' | translate }}
                        </th>
                        <th>{{ 'course.Status' | translate }}</th>
                        <th>{{ 'course.Date' | translate }}</th>
                        <th>{{ 'course.Certificate' | translate }}</th>
                        <th>{{ 'course.Certificate expiration date' | translate }}</th>
                        <th>{{ 'course.Personal deadline' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-class="{ status01: vm.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_PASSED==item.courseProgressStatus }"
                        ng-repeat="item in vm.list.items">
                        <td>
                            <a ng-click="vm.openCourseView(item)""> {{ item.name }}</a>
                        </td>
                        <td>{{ item.fields || '-' }}</td>
                        <td ng-if="vm.isOptionalCoursesModuleEnabled">
                            {{ vm.COURSE_TARGET_NEED_TYPE_ENUM.LABELS[item.targetType] || '-' }}
                        </td>
                        <td>{{ vm.getCourseStatus(item) }}</td>
                        <td>{{ vm.MomentService.format(item.coursePassedTime, 'DD.MM.YYYY') }}</td>
                        <td>
                            <span ng-if="!item.certificateId">-</span>
                            <a ng-if="item.certificateId"
                                ng-click="vm.downloadCertificate(item.certificateId, item.occurrenceId)"
                            >{{ 'course.Download certificate' | translate }}</a>
                        </td>
                        <td>
                            <span ng-if="item.externalParticipationId && item.externalParticipationExpireDate">
                                {{ vm.MomentService.formatDate(item.externalParticipationExpireDate) }}
                            </span>
                            <span ng-if="!item.externalParticipationId && item.certificateDeadline">
                                {{ vm.MomentService.formatDate(item.certificateDeadline) }}
                            </span>
                            <span ng-if="item.externalParticipationId ? !item.externalParticipationExpireDate : !item.certificateDeadline">-</span>
                        </td>
                        <td>{{ vm.MomentService.format(item.courseDeadline, 'DD.MM.YYYY') }}</td>
                    </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
        </div>
    `
})
export default class {
    constructor ($state, $window, $translate, DATATABLES, COURSE_PROGRESS_STATUS_TYPE_ENUM, COURSE_TARGET_NEED_TYPE_ENUM,
                 COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM, ListFactory, UserResource, AuthResource, MomentService,
                 TokenService) {
        this.$state = $state;
        this.$window = $window;
        this.DATATABLES = DATATABLES;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.AuthResource = AuthResource;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.UserResource = UserResource;
        this.ListFactory = ListFactory;
        this.language = $translate.use();
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.UserResource.courses.bind(this.UserResource));
        this.list.sort = '-coursePassedTime';
        this.list.fetch({
            userId: this.user.id,
            getCompletedCourses: true,
            pageSize: 5,
            'externalParticipationStatuses[]': [
                this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED,
                this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED_BY_DIRECT_MANAGER
            ]
        });
        this.isOptionalCoursesModuleEnabled = this.TokenService.isOptionalCoursesModuleEnabled();
    }

    getCourseStatus (course) {
        let status = this.COURSE_PROGRESS_STATUS_TYPE_ENUM.LABELS[course.courseProgressStatus];

        if (course.externalParticipationId) {
            status = this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[course.courseProgressStatus];
        }

        return status;
    }

    downloadCertificate (certificateId, occurrenceId) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}user/user/export-certificate/${certificateId}/${occurrenceId}?tacToken=${token}`;
                this.$window.open(url);
            });
    }

    openCourseView (course) {
        if (course.externalParticipationId) {
            this.$state.go('authorized.courses.participations.detail', { id: course.externalParticipationId });
        }
        else {
            this.$state.go(
                'authorized.courses.courses.edit.occurrence.edit.general',
                { id: course.id, occurrenceId: course.occurrenceId }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/courses/index.js